export default __webpack_public_path__ + "static/media/Group -16.000bf640.png";